import React from 'react';
import PropTypes from 'prop-types';

const alertBorderStyleProps = {
    border: '2px solid transparent',
    borderRadius: '0.25rem',
};

export const LightBlueAlert = (props) => (
    <div
        className="p-3"
        style={{
            backgroundColor: '#CCE5FF',
            borderColor: '#B8DAFF',
            ...alertBorderStyleProps,
        }}
    >
        {props.children}
    </div>
);

LightBlueAlert.propTypes = {
    children: PropTypes.any,
};

export const YellowAlert = (props) => (
    <div
        className="p-2"
        style={{
            backgroundColor: '#FFDEA6',
            borderColor: '#FFEEBA',
            ...alertBorderStyleProps,
        }}
    >
        {props.children}
    </div>
);

YellowAlert.propTypes = {
    children: PropTypes.any,
};
